import { useState, useContext, useEffect } from "react"
import { gql, useLazyQuery } from "@apollo/client"
import { LoaderMedium } from "../../Loaders"
import _ from "lodash"

import { Field, useFormikContext } from "formik"

import { Checkbox } from "primereact/checkbox"
import { FormContext } from "../../../context/formContext"
import { UserContext } from "../../../context/userContext"

import styles from "../../../styles/Form.module.css"

export default function CheckboxEnterpriseMicroservices({
  field,
  block,
  index,
}) {
  const [microserviceList, setMicroserviceList] = useState([])
  const [visible] = useState("block")
  const formik = useFormikContext()
  const form = useContext(FormContext)
  const userCtx = useContext(UserContext)

  let isDisabled = form ? form.blocksSaved[block] : false
  isDisabled = field.read_only ? true : isDisabled

  const GET_MICROSERVICES = gql`
    query getMicroservices(
      $staff_id: ID!
      $staff_organization_id: ID!
      $organization_id: ID!
    ) {
      microservices: getMicroservices(
        staff_id: $staff_id
        staff_organization_id: $staff_organization_id
        organization_id: $organization_id
        microservice_status: "ACTIVE"
      ) {
        microservices_id
        microservices_name
        microservices_alias
        microservices_description
        microservices_fee_amount
      }
    }
  `

  const [getMicroservices, { loading }] = useLazyQuery(GET_MICROSERVICES, {
    fetchPolicy: "no-cache",
    onCompleted: ({ microservices }) => {
      setMicroserviceList(microservices)
    },
    skip: !userCtx,
  })

  useEffect(() => {
    // Register field as loading in FormContext
    form && form.registerLoadingField(field)

    if (form?.editMode) {
      getMicroservices({
        variables: {
          staff_id: userCtx.session.user.staff_id,
          staff_organization_id: userCtx.session.user.organization_id,
          organization_id: userCtx.session.user.enterprise_id,
        },
      })
    } else {
      getMicroservices({
        variables: {
          staff_id: userCtx.session.user.staff_id,
          staff_organization_id: userCtx.session.user.organization_id,
          organization_id: "",
        },
      })
    }

    // Notify FormContext that field is loaded
    form && form.completeLoadingField(field)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (loading) {
    return (
      <div>
        <LoaderMedium />
      </div>
    )
  }

  return (
    <div
      className={styles.field}
      style={{
        order: index,
        display: visible,
      }}
    >
      {microserviceList.map((microservice, index) => {
        const field_name = `microservice_${_.replace(
          _.lowerCase(microservice.microservices_name),
          / /g,
          "_"
        )}`

        return (
          <div key={index} onBlur={() => formik.setFieldTouched(field_name)} className={styles.value}>
            <Field name={field_name}>
              {({ field: formikField, meta, form }) => {
                return (
                  <div
                    className={styles.field}
                    style={{
                      order: index,
                      display: visible,
                    }}
                  >
                    <Checkbox
                      disabled={isDisabled}
                      inputId={field_name}
                      name={field_name}
                      id={field_name}
                      value={microservice.microservices_id}
                      onChange={formikField.onChange}
                      checked={_.includes(
                        formikField.value,
                        microservice.microservices_id
                      )}
                    />
                    <label
                      htmlFor={field_name}
                      style={{ marginLeft: 5, fontWeight: "bold" }}
                    >
                      {microservice.microservices_alias}
                    </label>
                    {microservice.microservices_description && (
                      <div
                        className={styles.description}
                        dangerouslySetInnerHTML={{
                          __html: microservice.microservices_description,
                        }}
                      />
                    )}
                    {microservice.microservices_fee_amount && (
                      <p
                        style={{ marginLeft: 5, fontStyle: "italic" }}
                        className={styles.description}
                        dangerouslySetInnerHTML={{
                          __html: microservice.microservices_fee_amount,
                        }}
                      />
                    )}
                  </div>
                )
              }}
            </Field>
          </div>
        )
      })}
    </div>
  )
}
